export default __webpack_public_path__ + "4e98ddae2b98902d80ddeb19615b6405.png";